import { withInstall } from '../utils/index';
import Link from './index.vue';

export const TlbsLink = withInstall(Link);
export default TlbsLink;
